import * as yup from 'yup'
export const laundryBillingFilter = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  fechaPeriodoInicio: yup.string().required('La fecha inicio es obligatorio'),
  fechaPeriodoFin: yup.string().required('La fecha fin es obligatorio'),
})

export const laundryBilling2Filter = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
})
